module.exports = __webpack_public_path__ + "img/logo.7c8877ee.svg";